<template>
    <v-dialog v-model="dialog" max-width="350" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ $t('common.set_prescription') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12">
                        <kimsa-text-field :label="$t('exercises.tags')" outlined dense force-value no-elevation
                            :value="tags" @change="tags = $event" />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-combobox :label="$t('common.name')" outlined dense :items="prescriptions"
                            @change="prescription = $event" ref="prescriptions" can-write no-create-exercise
                            :loading="loadingSearch" @search="search = $event" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pa-0">
                <v-btn :disabled="disabled" @click="setPrescription" color="primary"
                    class="black--text normal-btn no-radius" depressed x-large block>
                    {{ $t('common.apply') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapState, mapMutations } from 'vuex'
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import { Client, PrescriptionIndex } from "@/utils/Algolia";
import { debounce } from '@/utils/Common'
import KimsaTextField from '../../common/inputs/KimsaTextField.vue';

export default {
    name: 'SetPrescriptionDialog',
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        category: {
            type: Object,
            default: null,
        },
        coachId: {
            type: String,
            default: null,
        },
    },
    components: {
        KimsaCombobox,
        KimsaTextField,
    },
    data() {
        return {
            dialog: false,
            prescriptions: [],
            prescription: null,
            search: '',
            loadingSearch: false,
            tags: '',
        }
    },
    computed: {
        ...mapState(['dialogActive', 'secondDialogActive']),
        disabled(vm = this) {
            return !vm.prescription
        }
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setSecondDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.isSecondDialog ? vm.setSecondDialogActive(true) : vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.isSecondDialog ? vm.setSecondDialogActive(false) : vm.setDialogActive(false)
            if (vm.$refs.prescriptions) vm.$refs.prescriptions.model = null
        },
        setPrescription() {
            const vm = this
            vm.$emit('set', vm.prescription)
            vm.hide()
        },
        async loadPrescriptions() {
            const vm = this;
            if (!vm.category) return
            vm.loadingSearch = true
            let filter = `coachId: ${vm.coachId} AND category: ${vm.category.id}`
            if (vm.tags) filter += ` AND tags:${vm.tags}`
            await Client.clearCache()
            let response = await PrescriptionIndex.search(vm.search, {
                filters: filter,
                hitsPerPage: 100,
            })
            vm.prescriptions = response.hits
            vm.loadingSearch = false
        },
        debouncedLoadPrescriptions: debounce(
            function () {
                this.loadPrescriptions()
            }, 1000),
    },
    watch: {
        dialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        secondDialogActive(val) {
            if (!val && this.dialog) this.hide()
        },
        category() {
            this.loadPrescriptions()
        },
        tags(val) {
            this.debouncedLoadPrescriptions()
        },
        search() {
            this.debouncedLoadPrescriptions()
        },
    }
}

</script>

<style scoped>
.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}
</style>